export default {
  'profilecredit.profilecreditreport': 'Credit Account Turnover',
  'profilecredit.creditstatus': 'Credit Status',
  'profilecredit.credittotalamount': 'Total amount of active credit',
  'profilecredit.creditremainamount': 'Total amount of remain credit',
  'profilecredit.profilecreditreport': 'Assigend Credits Report',
  'profilecredit.creditamount': 'Credit Amount',
  'profilecredit.remaincreditamount': 'Remain Credit Amount',
  'profilecredit.assigndate': 'Assigned Date',
  'profilecredit.duration': 'Duration(Day)',
  'profilecredit.active': 'Active',
  'profilecredit.expired': 'Expired',
  'profilecredit.sum': 'Sum',
  'profilecredit.expensesamount': 'Spent Amount',
  'profilecredit.nocredit': 'No Credit',
  'profilecredit.assigncredit': 'Assign Credit',
  'profilecredit.creditamountceiling': 'Credit Amount Ceiling',
  'profilecredit.deletecredit': 'Delete Credit',
  'profilecredit.deleteconfirmation': 'Are you sure to delete this credit?',
  'profilecredit.fullname': 'Full Name',
  'profilecredit.expensesreport': 'Expenses Report',
  'profilecredit.credit': 'Credit',
  'profilecredit.mycreditmanagement': 'My Credits Management',
  'profilecredit.creditmanagement': 'Credits Management',
  'profilecredit.employeecreditmanagement': 'Employee Credits Managemnt',
  'profilecredit.creditadd': 'Credit Added Successfully',
  'profilecredit.creditadderror':
    'There is already an active allocation for this profile',
  'profilecredit.noteligibleprofile':
    'This profile is not eligible for an allocation',
  'profilecredit.downloadexcel': 'Download Excel File',
  'profilecredit.fromdate': 'From Assigned Date',
  'profilecredit.todate': 'To Assigned Date',
};
